import React, { Component } from "react";
import { request } from "../../util/APIUtils";
import { ACCESS_TOKEN, API_BASE_URL } from "../../constants";
import "./SurveyQuestionsPage.css";
import Alert from "react-s-alert";
import { showAxiosError } from "../../util/Helpers";

class SurveyQuestionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      survey: null,
      error: null,
      loading: false,
      answers: [],
    };
  }

  componentDidMount() {
    this.fetchSurveyDetails();
  }

  fetchSurveyDetails() {
    const { match: { params } } = this.props;
    let self = this;
    let paramsReq = {
        url: `${API_BASE_URL}/anket/${params.id}`, 
        method: "GET",
    };

    self.setState({ loading: true });
    request(paramsReq)
        .then(function (response) {
            self.setState({
                survey: response.data,
                loading: false,
            });
        })
        .catch(function (error) {
            self.setState({
                loading: false,
                error: "Failed to fetch survey details.",
            });
        });
}


  handleInputChange = (event, questionId, choiceId) => {
    const answers = this.state.answers || {};
    const answer = {
      id: null,
      textResponse: choiceId ? null : event.target.value,
      choiceIndex: choiceId,
      question: { id: questionId },
    };
    answers[questionId] = answer;
    this.setState({ answers });
  };

  saveAnswers = () => {
    const { answers } = this.state;
    const { match: { params } } = this.props;
    const surveyId = params.id;

    const token = localStorage.getItem(ACCESS_TOKEN);
    console.log("Gönderilecek veri:", JSON.stringify(Object.values(answers)));

    const paramsReq = {
        url: `${API_BASE_URL}/answer/saveForSurvey/${surveyId}`, 
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        data: JSON.stringify(Object.values(answers)), 
    };

    request(paramsReq)
        .then((response) => {
            console.log("API Response:", response);
            console.log("Cevaplar başarıyla kaydedildi.");
            const message = "Cevaplar başarıyla kaydedildi!";
            Alert.success(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
         this.props.history.push("/anketler");
        })
        .catch((error) => {
            console.error("Cevaplar kaydedilirken bir hata oluştu:", error);
            showAxiosError(error);
        });
};


  render() {
    const { survey, loading, error } = this.state;

    return (
      <div className="survey-container">
        <h2>{survey ? survey.title : "Loading..."}</h2>
        {loading && <p>Loading...</p>}
        {error && <p className="error-message">{error}</p>}
        {survey &&
          survey.questions.map((question) => (
            <div key={question.id} className="question-card">
              <h3>{question.text}</h3>
              {question.questionType === "CHOICE" ? (
                <div className="choices">
                  {question.choices.map((choice) => (
                    <label key={choice.id}>
                      <input
                      type="radio"
                      name={`question-${question.id}`} // Düzeltme yapıldı
                      value={choice.choiceText}
                      onChange={(e) =>
                        this.handleInputChange(e, question.id, choice.id)
                    }
                />
                      {choice.choiceText}
                    </label>
                  ))}
                </div>
              ) : (
                <textarea
                  rows="2"
                  placeholder="Cevabınızı buraya yazın..."
                  onChange={(e) => this.handleInputChange(e, question.id)}
                ></textarea>
              )}
            </div>
          ))}
        <button
              onClick={this.saveAnswers}
              data-toggle="tooltip"
              data-placement="bottom"
              style={{
                background: 'linear-gradient(#2b93cd, #0a66b7)',
                float: "right",
                padding: "10px 54px 10px 23px",
                cursor:"pointer",
                fontSize:"10px"

              }}
              disabled={this.state.isLoading}
              className="TekBtn add-new-member "
              rel="tooltip"
              type="submit"
            >
                  Anketi Bitir
            </button>


      </div>
    );
  }
}

export default SurveyQuestionsPage;


// WEBPACK FOOTER //
// ./src/page/surveypage/SurveyQuestionsPage.js